import { auth } from 'firebase'

/**
 * authプロバイダーによるアカウント登録
 * 別途updateProfileを叩く必要がある。
 *
 * @param email
 * @param password
 */
export async function signup(email: string, password: string) {
  const userCredential = await auth().createUserWithEmailAndPassword(
    email,
    password
  )

  await userCredential.user.sendEmailVerification()

  return userCredential
}

export async function signOut() {
  return auth().signOut()
}

export function isLogin(req) {
  return !!req.session.user
}

/**
 * jwtの期限切れ?
 */
export function isJwtExpired(jwt: string) {
  const sigData = jwt.split('.')[1]
  if (!sigData) return null

  const decoded: any =
    typeof window !== 'undefined'
      ? atob(sigData)
      : Buffer.from(sigData, 'base64')

  return new Date(decoded.exp * 1000) < new Date()
}
